import { useQuery } from "@tanstack/react-query"
import { DCRReportFunction } from "./DCRReport_Repo"

export const useDCRReport = ({enable=false,param={}}:{enable:boolean,param:any})=>{
    return useQuery({
        queryKey:['GET_DCR_REPORT',param],
        queryFn:()=>DCRReportFunction(param),
        enabled:enable,
        retry:false
    })
}